import { defineMessages } from 'react-intl'

export default defineMessages({
  uploadTitle: {
    id: 'component.Commons.Search.uploadTitle',
    defaultMessage: 'Search by image',
  },
  orLabel: {
    id: 'component.Commons.Search.orLabel',
    defaultMessage: 'Or',
  },
  btnSearchLabel: {
    id: 'component.Commons.Search.btnSearchLabel',
    defaultMessage: 'Search',
  },
  copyLinkPlaceholder: {
    id: 'component.Commons.Search.copyLinkPlaceholder',
    defaultMessage: 'Copy the link of your image',
  },
  dragDropImage: {
    id: 'component.Commons.Search.dragDropImage',
    defaultMessage: 'Drag & drop an image here or',
  },
  browse: {
    id: 'component.Commons.Search.browse',
    defaultMessage: 'Browse',
  },
  addAnImage: {
    id: 'component.Commons.Search.addAnImage',
    defaultMessage: 'Add an image',
  },
  errorInvalidUrl: {
    id: 'component.Commons.Search.errorInvalidUrd',
    defaultMessage: 'Cannot use this link. Make sure that your link start with https://',
  },
  errorInvalidImageExtension: {
    id: 'component.Commons.Search.errorInvalidImageExtension',
    defaultMessage: 'This format is not accepted. Please use .jpg, .webp, .png, .gif',
  },
  errorUploadFailed: {
    id: 'component.Commons.Search.errorUploadFailed',
    defaultMessage: 'Upload failed',
  },
  searchByImagesTooltip: {
    id: 'component.Commons.Search.searchByImagesTooltip',
    defaultMessage: 'Search by images',
  },
  dropImageHere: {
    id: 'component.Commons.Search.dropImageHere',
    defaultMessage: 'Drop your image here',
  },
  errorImageSize: {
    id: 'component.Commons.Search.errorImageSize',
    defaultMessage: 'Max image size is limited to 15MB',
  },
})
